import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"
import { cn } from "../../lib/utils"
import { useTheme } from "../../styles/ThemeProvider"

const Separator = React.forwardRef(({ 
  className, 
  orientation = "horizontal", 
  decorative = true, 
  ...props 
}, ref) => {
  const { themeObject } = useTheme();
  
  // Obtener tokens del tema actual
  const separatorTokens = themeObject.components.separator || {};
  
  const separatorStyles = {
    flexShrink: 0,
    backgroundColor: separatorTokens.backgroundColor || themeObject.colors.border.default,
    height: orientation === "horizontal" ? (separatorTokens.thickness || '1px') : '100%',
    width: orientation === "horizontal" ? '100%' : (separatorTokens.thickness || '1px'),
  };

  return (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className
      )}
      style={separatorStyles}
      {...props}
    />
  );
})
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
